export interface BaseErrorBody {
    /* на backend тип code может отличаться от сервиса к сервису,
     в микросервисах nodejs - number/integer принят как согласованный */
    code: string | number,
    message: string,
    unparsed: unknown,
    status?: number,
}

export const getErrorMessage = (data: any): string => {
    if (!(data instanceof Object)) {
        return '';
    }

    if ('message' in data && typeof data.message === 'string') {
        return data.message;
    }

    return '';
};
